module.exports = __webpack_public_path__ + "img/s-i-wedding.b24cc313.jpeg";